export type EnemyKind = 'melee' | 'ranged';
export type RangedMovementMode = 'approach' | 'retreat' | 'strafe';

export const RANGED_ENEMY = {
  preferredMinDistance: 190,
  preferredMaxDistance: 285,
  attackMinDistance: 145,
  attackMaxDistance: 345,
  projectileSpeed: 220,
  projectileDamage: 10,
} as const;

export function getRangedMovementMode(distance: number): RangedMovementMode {
  if (distance < RANGED_ENEMY.preferredMinDistance) return 'retreat';
  if (distance > RANGED_ENEMY.preferredMaxDistance) return 'approach';
  return 'strafe';
}

export function canRangedEnemyShoot(
  distance: number,
  elapsedSinceLastShotMs: number,
  cooldownMs: number,
): boolean {
  return distance >= RANGED_ENEMY.attackMinDistance
    && distance <= RANGED_ENEMY.attackMaxDistance
    && elapsedSinceLastShotMs >= cooldownMs;
}

export function getRangedSpawnChance(elapsedSeconds: number): number {
  return Math.min(0.38, 0.18 + elapsedSeconds * 0.0015);
}
